<template>
  <div id="app">
    <!-- <div
      class="base-spinner spinner-border text-light"
      v-if="$store.state.loadingCount"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>-->
    <div class="loading-div" v-if="$store.state.loadingCount"></div>
    <div class="lds-ellipsis" v-if="$store.state.loadingCount" test>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <!-- <div id="nav">
      <router-link to="/home">Home</router-link>|
      <router-link to="/about">About</router-link>
    </div>-->
    <!-- <transition name="slide" mode="out-in"> -->
    <!-- <transition name> -->
    <!-- <keep-alive include="MainMenu"> -->
    <!-- <router-view :key="$route.fullPath" /> -->
    <keep-alive>
      <router-view :key="$route.name" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- </keep-alive> -->
    <!-- </transition> -->

    <div
      v-if="$store.state.messageText"
      class="alert bg-warning text-dark message-text elementToFadeInAndOut"
      role="alert"
      @click="clearMessageText"
    >
      <i class="fas fa-volume-up"></i>
      <span v-html="$store.state.messageText"></span>
      <!-- {{ $store.state.messageText }} -->
    </div>
  </div>
</template>
<script>
export default {
  metaInfo: {
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" }
    ]
  }
};
</script>

<style lang="scss" scoped>
html,
body {
  height: 100%;
}
#app {
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
.message-text {
  position: fixed;
  // width: 100%;
  max-width: 50%;
  left: 10px;
  bottom: 0;
  z-index: 99999;
  box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2), 0 9px 26px 0 rgba(0, 0, 0, 0.19);
}
.elementToFadeInAndOut {
  /* width: 200px; */
  /* height: 200px; */
  /* background: red; */
  -webkit-animation: fadeinout 3s 1 forwards;
  animation: fadeinout 3s 1 forwards;
}

@-webkit-keyframes fadeinout {
  0% {
    // bottom: -60px;
    // width: 0%;
    opacity: 0;
  }
  10% {
    // bottom: 0;
    // width: 100%;
    opacity: 1;
  }
  90% {
    // bottom: 0;
    // width: 100%;
    opacity: 1;
  }
  100% {
    // bottom: -60px;
    opacity: 0;
    // width: 0%;
  }
}

@keyframes fadeinout {
  0% {
    // width: 0%;
    opacity: 0;
  }
  10% {
    // width: 100%;
    opacity: 1;
  }
  90% {
    // width: 100%;
    opacity: 1;
  }
  100% {
    opacity: 0;
    // width: 0%;
  }
}
.loading-div {
  top: 0;
  position: fixed;
  background-color: #000;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  z-index: 9999999998;
}
.base-spinner {
  z-index: 9999999999;
  top: 5rem;
  position: fixed;
}
.lds-ellipsis {
  display: inline-block;
  position: absolute;
  width: 64px;
  height: 64px;
  z-index: 9999999999;
  margin-top: 20px;
  margin-left: -20px;
  div {
    position: fixed;
    margin-left: calc(50% - 20px);
    // left: 50%;
    top: 27px;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: #dfc;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  div:nth-child(1) {
    left: 6px;
    animation: lds-ellipsis1 0.6s infinite;
  }
  div:nth-child(2) {
    left: 6px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  div:nth-child(3) {
    left: 26px;
    animation: lds-ellipsis2 0.6s infinite;
  }
  div:nth-child(4) {
    left: 45px;
    animation: lds-ellipsis3 0.6s infinite;
  }
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}
/*slide transition*/
.slide-enter-active {
  transition: transform 0.2s ease-out;
}
.slide-leave-active {
  // transition: transform 0.1s ease-out;
}
.slide-enter {
  transform: translateX(-100%);
  transform: rotateY(90deg);
}
.slide-leave-to {
  transform: translateX(100%);
  transform: rotateY(90deg);
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.4s ease;
}
.slide-enter,
.slide-leave-to {
  transform: translateY(100%);
}
</style>
